<template>
  <div class="my-invoice">
    <div class="my-tabs">
      <div
        class="my-tabs-item"
        :class="{ active: active == 1 }"
        @click="tabClick(1)"
      >
        开具发票
      </div>
      <div
        class="my-tabs-item"
        :class="{ active: active == 2 }"
        @click="tabClick(2)"
      >
        我的发票
      </div>
    </div>
    <div class="invoice-screen" v-show="active == 1">
      <div
        class="screen-item"
        v-if="from.beginTime !== '' && from.endTime !== ''"
      >
        <span @click="beginTimeShow = true">{{ from.beginTime }}</span> ~
        <span @click="endTimeShow = true">{{ from.endTime }}</span>
        <img src="../../assets/img/icon-s.png" alt="" />
      </div>
      <div class="screen-item" @click="beginTimeShow = true" v-else>
        订单日期 <img src="../../assets/img/icon-s.png" alt="" />
      </div>
      <!-- @click="userTypeShow = true" -->
      <div class="screen-item">
        {{ vipTypesObj[from.type] ? vipTypesObj[from.type] : "会员类型" }}
      </div>
      <div class="screen-flex" @click="openScreen">
        筛选 <img src="../../assets/img/icon-ss.png" alt="" />
      </div>
    </div>
    <div class="invoice-flex" v-show="active == 1">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text=""
        @load="onLoad"
        :immediate-check="false"
        class="list-container"
        ref="vanList"
      >
        <div
          class="list-item"
          v-for="(item, index) in list"
          :key="index"
          :title="item"
        >
          <div class="item-header">
            <div class="radio" @click="radioClick(item, index)">
              <img
                src="../../assets/img/radio.png"
                v-if="!item.select"
                alt=""
              />
              <img src="../../assets/img/radio-yes.png" v-else alt="" />
            </div>
            <div class="item-header-flex">{{ item.staName }}</div>
            <div class="order-status" v-if="from.type == 2">
              {{ item.orderStatusDesc }}
            </div>
            <div class="order-status" v-if="from.type == 1">企业支付</div>
          </div>
          <div class="item-info" @click="gotoOrderDetail(item)">
            <div class="item-info-box">
              <div class="info-name">订单号</div>
              <div class="info-value">{{ item.orderNo }}</div>
            </div>
            <div class="item-info-box">
              <div class="info-name">开始时间</div>
              <div class="info-value">{{ item.chargeBeginTime }}</div>
            </div>
            <div class="item-info-box">
              <div class="info-name">时长</div>
              <div class="info-value">{{ item.chargeMinutes }}</div>
            </div>
            <div class="item-info-box">
              <div class="info-name">电量(度)</div>
              <div class="info-value">{{ item.chargeElect }}</div>
            </div>
          </div>
          <div class="order-money">
            金额(元)<span class="money">{{ item.transactionAmount }}</span>
          </div>
        </div>
        <pi-no-list-data :list="list" text="暂无发票">
          <img
            src="../../picture/no-data-icon/invoice.png"
            class="no-list-icon"
          />
        </pi-no-list-data>
      </van-list>
    </div>
    <div class="invoice-bottom" v-show="active == 1">
      <div class="select-info">
        <div class="all-radio" @click="pageAllClick">
          <img src="../../assets/img/radio.png" v-if="!pageAll" alt="" />
          <img src="../../assets/img/radio-yes.png" v-else alt="" />
          本页全选
        </div>
        <!-- <div class="all-radio" @click="allClick">
          <img src="../../assets/img/radio.png" v-if="!all" alt="">
          <img src="../../assets/img/radio-yes.png" v-else alt="">
          全选
        </div> -->
        <div class="select-info-flex">
          <span class="main-color">{{ selectOrder.length }}</span>
          笔订单，总计(元) <span class="main-color">{{ totalMoney }}</span>
        </div>
      </div>
      <!-- <p class="invoice-tips">仅支持个人充电订单开票(企业支付订单不支持开票)</p> -->
      <div class="next-box">
        <pi-button
          :type="selectOrder.length == 0 ? 'default' : 'primary'"
          block
          @click="nextClick"
          >下一步</pi-button
        >
      </div>
    </div>
    <div class="invoice-flex" v-show="active == 2">
      <van-list
        v-model="loading2"
        :finished="finished2"
        finished-text=""
        @load="onLoadList"
        :immediate-check="false"
        class="list-container"
        ref="vanList"
      >
        <ul class="my-invoice-list">
          <li
            class="invoice-item"
            @click="invoiceDetails(item)"
            v-for="(item, index) in list2"
            :key="index"
          >
            <div class="invoice-row">
              <div class="name">{{ item.applyTime }}</div>
              <div class="status" :class="{ red: item.applyStatus == 2 }">
                {{ item.applyStatusDesc }}
              </div>
            </div>
            <div class="invoice-row">
              <div class="name">
                <div class="name-tag">{{ item.invoiceTypeDesc }}</div>
              </div>
              <div class="value">{{ item.invoiceAccount }}元</div>
            </div>
          </li>
        </ul>
        <pi-no-list-data :list="list2" text="暂无发票">
          <img
            src="../../picture/no-data-icon/invoice.png"
            class="no-list-icon"
          />
        </pi-no-list-data>
      </van-list>
    </div>
    <pi-invoice-screen
      ref="invoiceScreen"
      @confirm="screenConfirm"
    ></pi-invoice-screen>
    <van-popup v-model="beginTimeShow" position="bottom">
      <van-datetime-picker
        @confirm="beginTimeConfirm"
        @cancel="beginTimeShow = false"
        v-model="beginTime"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
      />
    </van-popup>
    <van-popup v-model="endTimeShow" position="bottom">
      <van-datetime-picker
        @confirm="endTimeConfirm"
        @cancel="endTimeShow = false"
        v-model="endTime"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
      />
    </van-popup>
    <van-popup v-model="userTypeShow" position="bottom">
      <van-picker
        title="会员类型"
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        value-key="name"
        @cancel="userTypeShow = false"
        :default-index="0"
      />
    </van-popup>
  </div>
</template>

<script>
import { List, DatetimePicker, Popup, Picker } from "vant";
import noListData from "@/components/pi-no-list-data/pi-no-list-data.vue";
import screenInvoice from "./components/screen.vue";
import {
  getInvoiceChargeRecode,
  getInvoiceList,
  getAccountBaseInfo,
} from "../../common/api";

export default {
  components: {
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [List.name]: List,
    [screenInvoice.name]: screenInvoice,
    [noListData.name]: noListData,
  },
  data() {
    return {
      active: 1,
      all: false,
      pageAll: false,
      from: {
        beginTime: "",
        endTime: "",
        type: "",
        globalPageIndex: 1,
        globalPageSize: 10,
        maxTransactionAmount: "",
        minTransactionAmount: "",
      },
      totalMoney: 0,
      selectOrder: [],
      vipTypesObj: {
        2: "普通会员",
        1: "企业优惠",
      },
      from2: {
        globalPageIndex: 1,
        globalPageSize: 10,
      },
      loading: false,
      finished: false,
      list: [],
      list2: [],
      loading2: false,
      finished2: false,
      myInvoiceList: [],
      minDate: new Date(2019, 0, 1),
      maxDate: new Date(),

      beginTimeShow: false,
      endTimeShow: false,
      beginTime: new Date(2020, 0, 1),
      endTime: new Date(),
      columns: [
        { name: "全部", value: "0" },
        { name: "普通会员", value: "1" },
        { name: "企业优惠", value: "2" },
      ],
      userTypeShow: false,
    };
  },

  methods: {
    tabClick(index) {
      this.active = index;
      if (index == 2 && this.list2.length == 0) {
        this.getMyInvoiceList();
      }
    },
    pageAllClick() {
      this.pageAll = !this.pageAll;
      this.getSelectOrder(this.pageAll);
    },
    allClick() {
      this.all = !this.all;
      this.getSelectOrder(this.all);
    },
    onLoad() {
      if (!this.finished) {
        this.from.globalPageIndex++;
        this.getInvoiceList();
      }
    },
    onLoadList() {
      if (!this.finished2) {
        this.from2.globalPageIndex++;
        this.getMyInvoiceList();
      }
    },
    queryClick() {
      this.from.globalPageIndex = 1;
      this.list = [];
      this.finished = false;
      this.getInvoiceList();
    },
    getInvoiceList() {
      this.loading = true;
      if (this.list.length == 0) {
        this.selectOrder = [];
      }
      getInvoiceChargeRecode(this.from)
        .then((ret) => {
          if (ret.data) {
            let list = ret.data;
            list.map((item) => {
              item.select = false;
            });
            this.list = this.list.concat(ret.data);
            this.loading = false;
            if (this.list.length >= ret.total) {
              this.finished = true;
            }
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    radioClick(item, index) {
      item.select = !item.select;
      this.$set(this.list, index, item);
      this.getSelectOrder();
    },
    getSelectOrder(all) {
      let selectOrder = [];
      let list = [];
      this.list.map((item) => {
        if (all != undefined) {
          if (all) {
            item.select = true;
          } else {
            item.select = false;
          }
          console.log(item);
          list.push(item);
        }
        if (item.select) {
          selectOrder.push(item);
        }
      });
      this.selectOrder = selectOrder;
      let total = 0;
      selectOrder.map((item) => {
        total += item.transactionAmount;
      });
      this.totalMoney = total.toFixed(2);
      if (list.length > 0) {
        this.list = list;
      }
    },
    getMyInvoiceList() {
      this.loading2 = true;
      getInvoiceList(this.from2)
        .then((ret) => {
          let data = ret.data || [];
          this.list2 = this.list2.concat(data);
          this.loading2 = false;
          if (this.list2.length >= ret.total) {
            this.finished2 = true;
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading2 = false;
        });
    },
    nextClick() {
      let orderNo = [];
      this.selectOrder.map((item) => {
        orderNo.push(item.orderNo);
      });
      this.$common.save(
        "openInvoiceData",
        {
          orderNo: orderNo,
          money: this.totalMoney,
          type: this.from.type,
        },
        1
      );
      this.$router.push("/open-invoice");
    },
    screenConfirm(data) {
      this.from.maxTransactionAmount = data.maxMoney;
      this.from.minTransactionAmount = data.minMoney;
      this.queryClick();
    },
    openScreen() {
      this.$refs.invoiceScreen.open();
    },
    invoiceDetails(item) {
      this.$router.push(
        "/open-invoice-details?invoicePkId=" + item.invoicePkId
      );
    },
    beginTimeConfirm(value) {
      this.from.beginTime = this.$common.thisTimes(
        "yyyy-MM-dd",
        new Date(value)
      );
      this.beginTimeShow = false;
      this.queryClick();
    },
    endTimeConfirm(value) {
      this.from.endTime = this.$common.thisTimes("yyyy-MM-dd", new Date(value));
      this.endTimeShow = false;
      this.queryClick();
    },
    onConfirm(data) {
      this.from.userType = data.value;
      this.userTypeShow = false;
      this.queryClick();
    },
    getUserAccountMemory() {
      //获取获取账号信息
      getAccountBaseInfo(null, false).then((response) => {
        var accountObj = response.data[0];
        if (accountObj.vipName) {
          this.vipTypesObj["2"] = accountObj.vipName;
        }
      });
    },
  },
  mounted() {
    this.from.beginTime = this.$common.thisTimes(
      "yyyy-MM-dd",
      new Date(2020, 0, 1)
    );
    this.from.endTime = this.$common.thisTimes("yyyy-MM-dd");
    this.from.type = this.$route.query.type || "1";
    this.from2.type = this.$route.query.type || "1";
    this.$common.bodyAddBg();
    this.getInvoiceList();
    this.getUserAccountMemory();
  },
  destroyed() {
    this.$common.removeBodyBg();
  },
};
</script>

<style  lang="less">
@import url("./css/my-invoice.less");
</style>

